class PopoutCart {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }

    onInit () {
        const urlSearchParams = new URLSearchParams(window.location.search)
        if (urlSearchParams.get('show-cart')) {
            this._elem.classList.add('shown')
            document.dispatchEvent(new Event('popout-cart-shown'))
        }

        document.addEventListener('popout-cart-shown', e => {
            document.body.classList.add('no-scroll')
            document.body.classList.add('popout-cart--open')
        })
    }
}

export default PopoutCart



// WEBPACK FOOTER //
// ./src/resources/scripts/components/PopoutCart.js